import axios from "axios";
import authHelper from "sup8-front-auth";
import Cookies from "js-cookie";
import ut from "../utils/utils";
import _ from "lodash";
let baseURL
console.log(window.dockerConfig)
if(process.env.NODE_ENV === "development" || window.location.href.indexOf("identity2.yesno.com.cn") > -1 ) {
    baseURL = window.dockerConfig.base_fat_api
} else {
    baseURL = window.dockerConfig.base_pro_api
}
// 创建axios实例
const grayEnabled = Cookies.get("gray") === "1";
axios.defaults.headers.common["x-gray-enabled"] = grayEnabled;
axios.defaults.headers.common["x-request-lang"] = ut.getOSlanguage();
axios.defaults.headers.common["x-request-tz"] = ut.getTimezone();

const service = axios.create({
    timeout: 60 * 1000
});
// 请求拦截器
service.interceptors.request.use(
    (config) => {
        config.baseURL = baseURL;     
        config.headers = _.assign(config.headers, config.customHeader)
        config = authHelper.sign.getSignByReq(config);
        return config;
    },
    (error) => {
        // 处理请求错误
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    (response) => {
        const res = response.data;
        return res;
    },
    (error) => {
        return Promise.reject(error);
    }
);


export default service;
